'use client';

import { Stack, StackProps } from '@mui/material';
import Image from 'next/image';
import React from 'react';

import { cards } from '@/assets/materials/cards';

interface CoreHexIconProps extends StackProps {
  icon: any;
  alt?: string;
}

export const CoreHexIcon = ({ icon, alt = '', ...rest }: CoreHexIconProps) => {
  return (
    <Stack
      position={'relative'}
      width={{ xs: '40px', sm: '62px' }}
      height={{ xs: '40px', sm: '62px' }}
      alignItems={'center'}
      justifyContent={'center'}
      {...rest}>
      <Image
        width={32}
        height={32}
        src={icon}
        alt={alt}
        objectFit={'contain'}
        className={'w-5 h-5 sm:w-8 sm:h-8 z-10'}
      />
      <Stack position={'absolute'} top={0} left={0} right={0} bottom={0} zIndex={1}>
        <Image src={cards.card_icon} alt={alt} layout={'fill'} objectFit={'contain'} />
      </Stack>
    </Stack>
  );
};
